import React from 'react';
import { useStyles } from './ProgressViewerStep.styles';
import {
  ProgressViewerActionButton,
  ProgressViewerActionButtonProps,
} from '../ProgressViewerActionButton/ProgressViewerActionButton';

export type ProgressViewerStepProps = {
  stepStatus: 'Completed' | 'Current' | 'Upcoming';
  title: string;
  description?: string;
  actionButton?: ProgressViewerActionButtonProps;
};

export const ProgressViewerStep: React.FC<ProgressViewerStepProps> = ({
  stepStatus,
  title,
  description,
  actionButton,
}) => {
  const styles = useStyles();

  return (
    <>
      <div
        className={styles.stepContainer}
        style={
          {
            '--background-progress-viewer-step': stepStatus === 'Current' ? '#F7F7F7' : 'white',
          } as React.CSSProperties
        }
      >
        <div className={styles.lineSeparator}></div>
        <div
          className={styles.stepContent}
          style={
            {
              '--padding-progress-viewer-step': stepStatus === 'Current' ? '10px' : '8px',
            } as React.CSSProperties
          }
        >
          <div className={styles.stepTitle}>{title}</div>
          {getStatusIndicator(stepStatus, styles.statusIndicator, {
            '--top-progress-viewer-step': stepStatus === 'Current' ? '14px' : '12px',
          } as React.CSSProperties)}
          {description && stepStatus === 'Current' && (
            <div className={styles.stepDescription}>{description}</div>
          )}
          {actionButton && stepStatus === 'Current' && (
            <ProgressViewerActionButton {...actionButton} />
          )}
        </div>
      </div>
    </>
  );
};

const getStatusIndicator = (
  status: 'Completed' | 'Current' | 'Upcoming',
  className: string,
  styles: React.CSSProperties
) => {
  switch (status) {
    case 'Completed':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          style={styles}
        >
          <circle cx="8" cy="8" r="7" fill="#14AA0C" stroke="white" stroke-width="2" />
          <path
            d="M5.30078 8.59971L6.80078 10.0997L10.7008 6.19971"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case 'Current':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          className={className}
          style={styles}
        >
          <circle cx="5.5" cy="5.5" r="4.5" fill="#FF6600" />
          <circle cx="5.5" cy="5.5" r="4.5" stroke="white" stroke-width="2" />
          <circle
            cx="5.5"
            cy="5.5"
            r="4.5"
            stroke="#FF6600"
            stroke-opacity="0.2"
            stroke-width="2"
          />
        </svg>
      );
    case 'Upcoming':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          className={className}
          style={styles}
        >
          <circle cx="5.5" cy="5.5" r="4.5" fill="#E5E5E5" stroke="white" stroke-width="2" />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          className={className}
          style={styles}
        >
          <circle cx="5.5" cy="5.5" r="4.5" fill="#E5E5E5" stroke="white" stroke-width="2" />
        </svg>
      );
  }
};
